module.exports = __webpack_public_path__ + "static/media/22ESCWA10.2694d93a.jpg";